import { IUserPreferences } from 'src/models/interfaces/userPreferences';
import apiService from './api';

export class UserPreferencesService {
  public get(): Promise<any> {
    return apiService.get('/userPreferences');
  }

  public save(model: IUserPreferences<any>): Promise<void> {
    return apiService.post(`/userPreferences`, model);
  }
}

const userPreferencesService = new UserPreferencesService();
export default userPreferencesService;